import Color from 'color'

export const colorHexToHslCoords = (hexCode: string) => {
  const { h, s, l } = Color(hexCode).hsl().object()

  const round = (n: number) => Number(n.toFixed(2))

  return {
    h: round(h),
    s: round(s),
    l: round(l),
  }
}

export const colorHslToHex = ({ h, s, l }: { h: number; s: number; l: number }): string => {
  return Color.hsl(h, s, l).hex()
}
